import React from 'react';
import Icon from '../../../components/AppIcon';
import { ProjectFiltersProps, ProjectCategory } from '../types';

const ProjectFilters = ({ filters, onFiltersChange, categories: dynamicCategories }: ProjectFiltersProps) => {
  const categories = React.useMemo(() => {
    const cats = dynamicCategories || [
      { id: 'back-end', label: 'Back-end Development' },
      { id: 'design', label: 'Graphics Design' },
      { id: 'mobile-apps', label: 'Mobile Development' },
      { id: 'ui-ux', label: 'UI/UX Design' },
    ];
    // Ensure "All" is always at the beginning
    if (!cats.some(c => c.id === 'all')) {
      return [{ id: 'all', label: 'All' }, ...cats];
    }
    return cats;
  }, [dynamicCategories]);

  const handleCategoryToggle = (id: string, label: string) => {
    if (id === 'all') {
      onFiltersChange({ ...filters, categories: [] });
      return;
    }

    const current = filters.categories as string[];
    const updated = current.includes(label)
      ? current.filter(c => c !== label)
      : [...current, label];

    onFiltersChange({ ...filters, categories: updated as ProjectCategory[] });
  };

  const activeCategories = filters.categories as string[];

  return (
    <div className="flex flex-wrap justify-center gap-3 mb-16">
      {categories.map((cat: { id: string; label: string }) => (
        <button
          key={cat.id}
          onClick={() => handleCategoryToggle(cat.id, cat.label)}
          className={`px-6 py-3 text-[10px] font-black font-inter  tracking-widest transition-all duration-300 rounded-lg border-2 ${(cat.id === 'all' && activeCategories.length === 0) || activeCategories.includes(cat.label)
            ? 'bg-[#212121] border-[#212121] text-white shadow-[4px_4px_0px_0px_rgba(0,0,0,0.1)]'
            : 'bg-[#333333] border-[#333333]/10 text-white/70 hover:bg-[#2A2A2A] hover:text-white'
            }`}
        >
          {cat.label}
        </button>
      ))}
    </div>
  );
};

export default ProjectFilters;